import { cloneDeep } from 'lodash';
import { ColumnsLocalStorageKey } from '@/services/columns';
import { TagsLogicalRelationEnum } from '@/services/models/Enums';
import {saveUserDataToLocalStorage} from '@/services/localStorage-users-data';
import {logoutChatwootSession} from '@/services/utils/chatwoot';

export default {
  logout(state: any) {
    logoutChatwootSession();
    //localStorage.clear();
    const localStorageKeys = Object.keys(localStorage);
    localStorageKeys.forEach((key) => {
      if(key !== ColumnsLocalStorageKey) {
        localStorage.removeItem(key);
      }
    });

    //clear store data
    state.reportColumns.metrics = [];
    state.reportColumns.dimensions = [];
    state.reportColumns.savedColumns = {};
    state.table.query = {};
    state.table.queryTemporary = {};
    state.table.total = 0;
    state.table.offset = {};
    state.table.currentReport = null;
    state.table.nextReportTreeLevel = 0;
    state.table.nextReportGroup = null;
    state.table.activeReports = [];
    state.table.customGroups = null;
    state.table.selectedItems = [];
    state.table.previewLink = null;
    state.table.loading = false;
    state.table.selectedReport = null;
    state.table.drilldownFilter = null;
    state.table.notesOpened = false;
    state.table.chartOpen = false;
    state.table.chartHiddenSeries = {};
    state.table.activeTab = 0;
    state.table.filters = {};
    state.table.isHideFilters = false;
    state.table.settingsTabRoute = null;
    state.table.entityNames = {};
    
    state.errorsQuery = {};
    state.errorsQueryTemporary = {};
    state.errorsColumns = [];
    state.errorsTotal = 0;
    state.errorsOffset = 0;
    
    state.conversionsQuery = {};
    state.conversionsQueryTemporary = {};
    state.conversionsColumns = [];
    state.conversionsOffset = 0;
    state.conversionsTotal = 0;
    state.tabChatVis = false;
    
    state.livesQuery = {};
    state.livesColumns = [];
    state.livesTotal = 0;
    state.livesOffset = 0;
    
    state.tutorial.quickStart = false;
    state.tutorial.quickStartStep = 0;
    state.tutorial.quickStartSection = null;
    state.tutorial.quickStartHiddenClass = false;

    state.dashboard.query = {};
    state.dashboard.queryTemporary = {};
    state.dashboard.sortBy = '';

    state.user = {};
    state.acl = null;
    state.isAuthenticated = null;
    state.isAuthorized = false;
    state.member = null;
    state.authToken = null;
    state.impersonation = {
      id:null,
      email:null
    };
    state.alertsCount = 0;
    state.report.showFilters = false;
    state.table.noReportBlockVisible = false;
    state.table.progressBlockVisible = false;
    state.bookmarks = [];
    state.table.menuOverride = null;
    state.table.entityNames = {};
    state.table.activeTabStack = [];
    state.table.customEvents = {};

    state.mobile.menuOpen = false;
    state.mobile.menuGroupingOpen = false;
    state.mobile.menuGroupingTop = 0;
    state.mobile.menuReportTabsOpen = false;
    state.mobile.menuReportTabsTop = 0;
    state.mobile.desktopViewForced = null;
    state.mobile.desktopViewForcedCurrent = null;

    state.appError = '';
    state.panelBlocked = false;
    state.isLoading = false;
    state.cache = {
      campaigns: {
        data:[],
        isUploaded:false,
        isAllInCache:false,
      },
      landings: {
        data:[],
        isUploaded:false,
        isAllInCache:false,
        uploadedForWorkspace:null,
        uploadedForCountryId:null
      },
      tags: {
        campaigns:{
          data:[],
          isUploaded:false,
        },
        offers:{
          data:[],
          isUploaded:false,
        },
        landings:{
          data:[],
          isUploaded:false,
        },
        flows:{
          data:[],
          isUploaded:false,
        },
        'traffic-sources':{
          data:[],
          isUploaded:false,
        },
        'affiliate-networks':{
          data:[],
          isUploaded:false,
        },
      },
      offers: {
        data:[],
        isUploaded:false,
        isAllInCache:false,
        uploadedForWorkspace:null,
        uploadedForCountryId:null
      },
      trafficSources: {
        data:[],
        isUploaded:false,
        isAllInCache:false,
        uploadedForWorkspace:null
      },
      affiliateNetworks: {
        data:[],
        isUploaded:false,
      },
      trackingDomains: {
        data:[],
        isUploaded:false,
      },
      redirectDomains: {
        data:[],
        isUploaded:false,
      },
      integrations: {
        data:[],
        isUploaded:false,
      },
      flows: {
        data:[],
        isUploaded:false,
        isAllInCache:false,
        uploadedForWorkspace:null,
        uploadedForCountryId: null
      },
    }
  },

  login(state: any, user: any) {
    if (user) {
      state.isAuthorized = true;
      state.isAuthenticated = !!window.localStorage.getItem('auth-token');
      state.authToken = window.localStorage.getItem('auth-token');

      // example how to hardcode feature flags
      
      // user.featureFlags = {
      //   integrations: {
      //     enabled: true,
      //     meta: {
      //       trafficSources: ["propeller", "revcontent", "exoclick"]
      //     }
      //   }
      // }
      state.user = user;
    }
  },
  updateUser(state: any, user: any) {
    const updatedUser = Object.assign(cloneDeep(state.user), user);
    
    state.user = updatedUser;
    if(user.selectedWorkspaces){
      saveUserDataToLocalStorage(updatedUser?.id,{selectedWorkspaces:updatedUser.selectedWorkspaces});
    }
  },
  secondFactorAuth(state: any, success: boolean) {
    state.isAuthorized = success;
  },

  saveUserAcl(state: any, acl: any) {
    state.acl = acl;
  },
  member(state: any, member: any) {
    state.member = member;
  },
  authToken(state: any, member: any) {
    state.authToken = member;
  },
  userInheritColumns(state: any, payload: boolean) {
    state.userInheritColumns = payload;
  },
  isProfileLoaded(state: any, payload: boolean) {
    state.isProfileLoaded = payload;
  }
};
